import { MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 6rem);
  position: fixed;
  top: 6rem;
  left: 0;
  right: 0;
  z-index: 999;
  transform: ${(props) => (props.isActive ? "translateX(-350px)" : "translateX(0px)")};
  background-color: black;
  padding-top: 5rem;
  padding-bottom: 5rem;
  overflow: auto;

  @media screen and (min-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;

export const TopMenu = styled.div`
  width: 100%;
  height: 5.2rem;
  margin-bottom: 1rem;
  padding: 14px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > span {
    font-size: 2rem;
    line-height: 2.4rem;
    font-weight: 700;
  }

  & > img {
    transform: ${(props) => (props.isActive ? "rotate(180deg)" : "")};
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const SideMenuContainer = styled.div`
  width: 100%;
  background-color: #131315;
  height: 100%;
`;

export const SideMenu = styled.div`
  width: 100%;
  padding: 17px 0 17px 40px;
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 2.2rem;
  margin-bottom: 1rem;
`;

export const ShareBtn = styled.div`
  width: 11rem;
  height: 4.6rem;
  background-color: ${MAIN_GREEN};
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  border-radius: 0.5rem;
  margin-left: 20px;
  margin-top: 20rem;

  & > img {
    width: 2rem;
    height: 2rem;
    margin-right: 1rem;
  }
  & > span {
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.8rem;
  }
`;
